module.exports = __webpack_public_path__ + "static/media/panel-time.bcddabbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/schedule/panel-time.png
// module id = 2046
// module chunks = 6